// Data LOCAL, não UTC: `toISOString()` às 21h no Brasil (UTC−3) já devolve o
// dia seguinte, e o filtro "Hoje" passava a buscar amanhã — no horário de pico.
export const dataLocal = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const OPCOES_PERIODO = [
  { key: "hoje", label: "Hoje" },
  { key: "ontem", label: "Ontem" },
  { key: "mes", label: "Este mês" },
  { key: "mes_passado", label: "Mês passado" },
  { key: "custom", label: "Personalizado" },
];

export function calcularDatas(filtro, dataInicio, dataFim) {
  const hoje = new Date();
  switch (filtro) {
    case "hoje": return { inicio: dataLocal(hoje), fim: dataLocal(hoje) };
    case "ontem": {
      const d = new Date(hoje);
      d.setDate(d.getDate() - 1);
      return { inicio: dataLocal(d), fim: dataLocal(d) };
    }
    case "mes_passado": {
      // Dia 0 do mês atual = último dia do anterior (28/30/31 e virada de ano).
      const inicio = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
      const fim = new Date(hoje.getFullYear(), hoje.getMonth(), 0);
      return { inicio: dataLocal(inicio), fim: dataLocal(fim) };
    }
    case "custom": return { inicio: dataInicio || dataLocal(hoje), fim: dataFim || dataLocal(hoje) };
    default: return { inicio: dataLocal(new Date(hoje.getFullYear(), hoje.getMonth(), 1)), fim: dataLocal(hoje) };
  }
}

// Sufixo do nome do arquivo exportado: 20260901_20260921.
export const rotuloArquivo = ({ inicio, fim }) => `${inicio.replace(/-/g, "")}_${fim.replace(/-/g, "")}`;

// "01/08–21/08", "20/09" (um dia só) ou "01/09/2025–21/09/2025" quando o ano
// não é o atual — sem o ano, a comparação com o ano anterior pareceria o mesmo período.
export function faixaDatas(periodo) {
  if (!periodo?.inicio) return "";
  const anoAtual = new Date().getFullYear();
  const fmt = (iso) => {
    const [a, m, d] = iso.split("-");
    return Number(a) === anoAtual ? `${d}/${m}` : `${d}/${m}/${a}`;
  };
  return periodo.inicio === periodo.fim ? fmt(periodo.inicio) : `${fmt(periodo.inicio)}–${fmt(periodo.fim)}`;
}
